import { combineReducers } from 'redux';
import appReducer from './appReducer';
import counterReducer from './counterReducer';
import loggedReducer from './isLoggedReducer';
import searchReducer from './searchReducer';
import reportsReducer from './reportsReducer';
import biblioReducer from './biblioReducer';
import sortReducer from './sortReducer';
import createReducer from './createReducer';
import mergeReducer from './mergeReducer';
import downloadReducer from './downloadReducer';
import trackerReducer from './trackerReducer';
import mlModelsReducer from './mlModelsReducer';


export default combineReducers({
  app: appReducer,
  counter: counterReducer,
  isLogged: loggedReducer,
  //login: isLoggedReducer
  search: searchReducer,
  reports: reportsReducer,
  biblio: biblioReducer,
  sort: sortReducer,
  create: createReducer,
  merge: mergeReducer,
  download: downloadReducer,
  tracker: trackerReducer,
  mlModels: mlModelsReducer
});
